/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';

import type {
	useDataRetentionPolicyGetPolicyQuery as useDataRetentionPolicyGetPolicyQuery$data,
	useDataRetentionPolicyGetPolicyQueryVariables as useDataRetentionPolicyGetPolicyQuery$variables,
} from './__types__/useDataRetentionPolicyGetPolicyQuery.js';

export const useDataRetentionPolicyGetPolicyQuery = gql`
	query useDataRetentionPolicyGetPolicyQuery($cloudId: ID!) {
		confluence_dataLifecycleManagementPolicy(cloudId: $cloudId) {
			isDataRetentionPolicyEnabled
		}
	}
`;

export const useDataRetentionPolicy = () => {
	const { cloudId } = useSessionData();

	const { data, error, loading } = useQuery<
		useDataRetentionPolicyGetPolicyQuery$data,
		useDataRetentionPolicyGetPolicyQuery$variables
	>(useDataRetentionPolicyGetPolicyQuery, {
		skip: !cloudId || !fg('dlp-dlm-data-retention-policy'),
		variables: {
			cloudId,
		},
	});

	return {
		isDataRetentionPolicyEnabled:
			data?.confluence_dataLifecycleManagementPolicy?.isDataRetentionPolicyEnabled,
		error,
		loading,
	};
};
